import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar.jsx'
import '../pedido-editar/pedido-editar.css'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import api from '../../services/api.js'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode.jsx'
import apinode from '../../services/apinode.js'
import { set } from 'date-fns'
import { format, parse } from 'date-fns'
import { NumberFormat } from 'react-number-format'
import { Spinner } from 'react-bootstrap'
import swal from 'sweetalert'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { Table, Form, InputGroup, Button, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faCartArrowDown } from '@fortawesome/free-solid-svg-icons'
import clientesPDF from './report.jsx'
import ReactInputMask from 'react-input-mask'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import InputMask from 'react-input-mask'
import CalcularParcelas from './calculator.jsx'
import Swal from 'sweetalert2'

function PedidoCompra() {
  const { id_pedido } = useParams()
  const navigate = useNavigate()
  const { conta, print } = useParams()
  const [textoDigitado, setTextoDigitado] = useState('')
  const [estaBuscando, setEstaBuscando] = useState(true)

  const [dt_pedido, setDtPedido] = useState('')
  const [id_cond_pagto, setIdCondPagto] = useState(0)
  const [dt_entrega, setDtEntrega] = useState('')
  const [obs, setObs] = useState('')
  const [produtos, setProdutos] = useState([])
  const [vl_total, setVlTotal] = useState(0)
  const [msg, setMsg] = useState('')
  const [desconto, setDesconto] = useState(0)
  const [vendedor, setVendedor] = useState('')
  const [indicacaoVenda, setIndicacaoVenda] = useState('')
  const [lista_produtos, setListaProdutos] = useState([])
  const [lista_clientes, setListaClientes] = useState([])
  const [cond_pagtos, setCondPagtos] = useState([])
  const [produtoBanco, setProdutoBanco] = useState('')
  const [matchResultado, setMatchResultado] = useState(null)
  const [matchproduto, setMatchProduto] = useState('')
  const [codinterno, setCodigoInterno] = useState('')
  const [id_cliente, setIdCliente] = useState('')
  const [nomeCliente, setNomeCliente] = useState('')
  const [cliente, setCliente] = useState('')
  const [cpf, setCpf] = useState('')
  const [dadospedido, setDadosPedido] = useState('')
  const [vendedores, setVendedores] = useState([])
  const [parceiros, setParceiros] = useState([])
  const [parceiro, setParceiro] = useState('')
  const [detalhesPedido, setDetalhesPedido] = useState('')
  const [descontoItem, setDescontoItem] = useState([])
  const [dadosEmp, setDadosEmp] = useState([])
  const [isLoading, setLoading] = useState(null)
  const [contas, setConta] = useState([])
  const [contaSelecionada, setContaSelecionada] = useState('')
  const [orderID, setIdpedidoLoja] = useState('')
  const [endEnt, setEndEnt] = useState('')
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [frete, setFrete] = useState(0)
  const [cobraFrete, setCobraFrete] = useState('')
  const calcRef = useRef()
  const [duplicatasPedido, setDuplicatasPedido] = useState([])
  const [totalCompra, setTotalCompra] = useState(0)
  const [diasParcelas, setDiasParcelas] = useState('')
  const [resultado, setResultado] = useState([])
  const [observacaoEditavel, setObservacaoEditavel] = useState('')
  const [loadingTela, setLoadingTela] = useState(null)
  const [nfePedido, setNfepedido] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showModalEst, setShowModalEst] = useState(false)
  const [idNFe, setIdNfe] = useState('')
  const [produtosEstoque, setProdutosEstoque] = useState([])
  const [quantidadesSelecionadas, setQuantidadesSelecionadas] = useState({})
  const [produtosBaixar, setprodutosBaixar] = useState([])
  const [lancContas, setLanContas] = useState('')
  const [statusPedido, setStatus] = useState('')
  const [tipoVenda, setTipoVenda] = useState('')
  const [comissao, setComissao] = useState('')

  const handleEstorno = async (order) => {
    let retorno
    if (window.confirm('Tem certeza que deseja estornar este pedido?')) {
      try {
        const response = await apinode.get(
          `/pedido/estornoPedido/${order}/${localStorage.idconta}`,
          {
            params: {
              pedido: order,
            },
          },
        )

        retorno = response.data
        if (response.status === 200) {
          console.log('Estorno realizado')
          toast.success(response.data.message)
          // setPedido('');
        } else {
          console.error(
            'Erro ao solicitar estorno ao backend. Resposta:',
            response.data,
          )
          toast.error(
            `Erro ao solicitar estorno ao backend. Resposta: ${response.data}`,
          )
          //  setPedido('');
        }
      } catch (error) {
        console.error('Erro ao buscar contas:', error)
        toast.error(`Erro ao solicitar estorno. Resposta: ${retorno}`)
        // setPedido('');
      }
    }
  }

  const HandleBaixarEstoque = async () => {
    try {
      setLoading(true)

      // Verificar se há algo em produtosBaixar
      if (produtosBaixar && produtosBaixar.length > 0) {
        const response = await apinode.put(
          `/pedido/itens/${id_pedido}/${localStorage.idconta}`,
          produtosBaixar,
        )
        toast.success(response.data.message)
        setprodutosBaixar([])
      } else {
        toast.warning('Nenhum produto para baixar no estoque.')
      }
    } catch (error) {
      console.error(error)
      toast.error('Erro ao acessar produtos: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleCusto = async (vlr, index) => {}

  const HandleLanc = async () => {
    if (lancContas === 'S') {
      const confirmDelete = window.confirm(
        'Contas já foram lançadas! Para prosseguir, você precisa excluir manualmente os lançamentos anteriores. Deseja continuar?',
      )

      if (!confirmDelete) {
        return
      }
    }

    try {
      setLoading(true)

      // Verificar se há algo em produtosBaixar
      if (resultado && resultado.length > 0) {
        const response = await apinode.post(
          `/pedido/contasareceber/${id_pedido}/${id_cliente}/${localStorage.idconta}`,
          resultado,
        )
        toast.success(response.data.message)
      } else {
        toast.warning('Nenhuma duplicata para lancar')
      }
    } catch (error) {
      console.error(error)
      toast.error('Erro ao acessar produtos: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleCheckboxChangeEst = (produtoInfo) => {
    const [sku, quantidade] = produtoInfo

    setQuantidadesSelecionadas((prevQuantidades) => {
      const updatedQuantidades = { ...prevQuantidades }
      updatedQuantidades[sku] = {
        quantidade,
        selected: !prevQuantidades[sku]?.selected,
      }

      const quantidadesArray = Object.entries(updatedQuantidades)
        .filter(([_, { selected }]) => selected) // Filtra apenas os itens com selected igual a true
        .map(([sku, { quantidade, selected }]) => ({
          sku,
          quantidade,
          selected,
        }))

      console.log(quantidadesArray)
      setprodutosBaixar(quantidadesArray)
      return updatedQuantidades
    })
  }

  const HandleEstoque = async () => {
    try {
      setLoading(true)
      const response = await apinode.get(
        `/pedido/itens/${id_pedido}/${localStorage.idconta}`,
      )
      setProdutosEstoque(response.data)
      setShowModalEst(true)
      console.log(response.data)
    } catch (error) {
      console.error(error)
      toast.error('Erro ao acessar produtos: ' + error.message)
    } finally {
      setLoading(false)
    }
  }
  const handleCloseModal = () => {
    setShowModal(false)
  }
  const handleCloseModalEst = () => {
    setShowModalEst(false)
  }

  const HandleCreateNFE = () => {
    let mensagem = ''

    if (nfePedido === 'S') {
      mensagem =
        'Venda já registrada com NFE. Deseja criar uma nova?\n\n' +
        'Ao gerar uma nova NFE para este pedido, você corre o risco de duplicar a documentação fiscal. ' +
        'Isso pode levar a problemas com a Receita Federal e causar confusões para o cliente. ' +
        'Certifique-se de que essa ação é realmente necessária.\n\n' +
        'Deseja continuar?'
    } else {
      mensagem =
        'Deseja criar NFE para o pedido?\n\n' +
        'Ao gerar uma NFE, certifique-se de que esta ação é necessária para evitar duplicação de documentação fiscal. ' +
        'Prossiga apenas se tiver certeza.\n\n' +
        'Deseja continuar?'
    }

    const confirmacao = window.confirm(mensagem)

    if (!confirmacao) {
      return
    }

    setLoading(true)
    const dados_pedido = {
      valorfrete: frete,
      emp_conta: contaSelecionada,
      codcliente: id_cliente || 0,
      datavenda: dt_pedido || moment().format('YYYY-MM-DD'),
      totalpedido: vl_total,
      observacao_interna: `NUMERO DO PEDIDO ${id_pedido}, nickName ${nomeCliente}`,
      natureza: 'S',
      numero_venda: id_pedido,
      valorfrete: frete,
      itens: produtos,
      /*   desconto: desconto || null,
              desconto_din: desconto || 0,
              id_parceiro: indicacaoVenda || null,
              cpf: cpf,
              detalhes_pedido: detalhesPedido || 'Não informado',
              end_ent: endEnt || null,
              itens: produtos,
              dadosDoCliente: endereco,
              cobra_frete: cobraFrete,
              duplicatas: resultado, */
    }

    apinode
      .post(`/pedido/nfe/${id_pedido}/${localStorage.idconta}`, dados_pedido)
      .then((response) => {
        const novoPedidoId = response.data.idnfe // Suponha que o ID do pedido esteja em id_pedido, ajuste conforme necessário
        console.log(`NFE criada com sucesso! ID: ${novoPedidoId}`)
        setIdNfe(novoPedidoId)
        toast.success(response.data.message)
        setLoading(false)
        setShowModal(true)
        //navigate(`/pedido/editar/${novoPedidoId}`)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro ao criar o pedido: ' + error.message)
        setLoading(false)
      })
  }

  const calcularParcelas = () => {
    let totalfrete = 0
    let total = 0

    if (isNaN(parseFloat(vl_total))) {
      console.error('O valor total da compra não é válido.')
      return
    }

    // Supondo que 'frete' seja o valor do frete
    if (frete > 0) {
      if (
        confirm(
          `Deseja adicionar o valor do frete (${frete}) ao total da compra?`,
        )
      ) {
        totalfrete = frete
        total = parseFloat(vl_total) + parseFloat(totalfrete)
      } else {
        total = parseFloat(vl_total)
      }
    } else {
      total = parseFloat(vl_total)
    }

    const diasArray = diasParcelas
      .split(',')
      .map((dias) => parseInt(dias.trim()))

    if (diasArray.some(isNaN) || diasArray.some((dias) => dias <= 0)) {
      console.error('A entrada de dias de vencimento não é válida.')
      return
    }

    const dt_pedido_obj = new Date(dt_pedido)
    if (isNaN(dt_pedido_obj.getTime())) {
      console.error('A data do pedido não é válida.')
      return
    }

    const parcelas = diasArray.map((dias, index) => {
      const datavencimento = new Date(dt_pedido_obj)
      datavencimento.setDate(datavencimento.getDate() + dias)

      const valorParcela = total / diasArray.length

      return {
        numero: index + 1,
        datavencimento: `${datavencimento}`,
        valor: valorParcela.toFixed(2),
        obs: '', // Adicione um campo para a observação
      }
    })

    setResultado(parcelas)
    console.log(parcelas)
  }

  const handleEditarObservacao = (numeroParcela, novaObservacao) => {
    const novasParcelas = resultado.map((parcela) =>
      parcela.numero === numeroParcela
        ? { ...parcela, obs: novaObservacao }
        : parcela,
    )
    setResultado(novasParcelas)
  }

  const handleExcluirParcela = (numeroParcela) => {
    const novasParcelas = resultado.filter(
      (parcela) => parcela.codigo !== numeroParcela,
    )
    setResultado(novasParcelas)

    // Recalcular total da compra
    const novoTotal = novasParcelas.reduce(
      (acumulado, parcela) => acumulado + parseFloat(parcela.valor),
      0,
    )
    setTotalCompra(novoTotal.toFixed(2))
  }

  // Supondo que dt_pedido seja a data no formato 'dd/MM/yyyy'

  const HandleCadastrarCliente = (e) => {
    e.preventDefault()
    apinode
      .post(`pessoa/${localStorage.idconta}`, endereco)
      .then((response) => {
        console.log(response.data)
        toast.success('Cliente cadastrado com sucesso!')
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro, ' + error.response.data.message)
        // Handle the error appropriately here
        setLoading(false)
      })
  }

  function buscaCep() {
    const fornecedorCepInput = document.getElementById('cep')
    const cep = fornecedorCepInput.value.replace(/\D/g, '')
    const url = `https://viacep.com.br/ws/${cep}/json/`
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url)
    xhr.onload = function () {
      const response = JSON.parse(xhr.responseText)
      setEndereco({
        ...endereco,
        pes_ibge: response.ibge,
        pes_bairro: response.bairro,
        pes_cidade: response.localidade,
        pes_uf: response.uf,
        pes_logradouro: response.logradouro,
      })
    }
    xhr.send()
  }

  const handleOpenAddressModal = () => {
    setShowAddressModal(true)
  }
  const handleCloseAddressModal = () => {
    setShowAddressModal(false)
  }
  const [endereco, setEndereco] = useState({
    pes_logradouro: '',
    pes_numero: '',
    pes_cidade: '',
    pes_uf: '',
    pes_cep: '',
    pes_telefone: '',
    pes_celular: '',
    pes_tipo: 'F',
    pes_razao: '',
    pes_cnpj_cpf: '',
    cod_tipo_contribuinte: '99',
    pes_bairro: '',
    pes_ibge: '',
    pes_insc_estadual: '',
  })

  const handleNomeChange = (e) => {
    setEndereco({
      ...endereco,
      pes_razao: e.target.value,
    })
  }

  const handleCpfCnpjChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '') // Remove todos os caracteres não numéricos
    setEndereco({
      ...endereco,
      pes_cnpj_cpf: rawValue,
    })
  }

  const handleRuaChange = (e) => {
    setEndereco({ ...endereco, pes_logradouro: e.target.value })
  }

  const handleNumeroChange = (e) => {
    setEndereco({ ...endereco, pes_numero: e.target.value })
  }

  const handleCidadeChange = (e) => {
    setEndereco({ ...endereco, pes_cidade: e.target.value })
  }
  const handleRGIEChange = (e) => {
    setEndereco({ ...endereco, pes_insc_estadual: e.target.value })
  }
  const handleEstadoChange = (e) => {
    setEndereco({ ...endereco, pes_uf: e.target.value })
  }
  const handleBairroChange = (e) => {
    setEndereco({ ...endereco, pes_bairro: e.target.value })
  }
  const handleCepChange = (e) => {
    setEndereco({ ...endereco, pes_cep: e.target.value })
  }

  const handlePesIbge = (e) => {
    setEndereco({ ...endereco, pes_ibge: e.target.value })
  }

  const handleTelefoneChange = (e) => {
    setEndereco({ ...endereco, pes_telefone: e.target.value })
  }

  const handleCelularChange = (e) => {
    setEndereco({ ...endereco, pes_celular: e.target.value })
  }

  const handleTipoCadastroChange = (e) => {
    setEndereco({
      ...endereco,
      pes_tipo: e.target.value || 'F',
    })
  }

  const handleTipoContribuinte = (e) => {
    setEndereco({
      ...endereco,
      cod_tipo_contribuinte: e.target.value,
    })
  }

  const handleContaChange = (event) => {
    setContaSelecionada(event.target.value)
  }

  const handleTipoVenda = (event) => {
    setTipoVenda(event.target.value)
  }

  const fetchAccounts = async () => {
    try {
      const response = await apinode.get(
        `/pedido/contas/${localStorage.idconta}`,
      )

      setConta(response.data)
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
    }
  }
  const clientes = [
    {
      nome: 'João',
      idade: 30,
      email: 'joao@example.com',
      telefone: '(00) 1234-5678',
    },
    {
      nome: 'Maria',
      idade: 25,
      email: 'maria@example.com',
      telefone: '(00) 9876-5432',
    },
    {
      nome: 'Pedro',
      idade: 40,
      email: 'pedro@example.com',
      telefone: '(00) 5555-8888',
    },
  ]

  function ImpPdf(tipo) {
    const dados_pedido = {
      valor_frete: frete,
      cobra_frete: cobraFrete,
      EnderecoEnt: endEnt,
      numeroorc: id_pedido,
      orderid: orderID,
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: descontoItem || null,
      desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos,
      empresa: dadosEmp,
      dadosDoCliente: endereco,
      tipo_pedido: tipoVenda,
    }

    clientesPDF(dados_pedido, tipo)
    console.log(dados_pedido)
  }

  const reqToken = async (conta) => {
    try {
      const response = await apinode.get('/emp', {
        params: {
          token: conta,
        },
      })

      if (response.status === 200) {
        const token = response.data?.ID_CONTA
        console.log('token: ' + token)

        if (!token) {
          // Sessão expirada ou token não encontrado
          swal(
            'Sessão expirada',
            'Por favor, feche e abra novamente.',
            'warning',
          )
        } else {
          // Atribuição para o state ou local storage (se necessário)
          setDadosEmp([response.data]) // Define o state "dadosEmp" com os dados recebidos
          localStorage.setItem('id_conta', token) // Define o "id_conta" no local storage
        }
      } else {
        console.log('Erro ao requisitar token. Status: ' + response.status)
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
      // Tratamento de erro adicional, se necessário
      // Por exemplo, exibir uma mensagem de erro para o usuário
      swal('Erro na requisição', 'Ocorreu um erro ao buscar o token.', 'error')
    }
  }

  const handleDescontoTotal = (value) => {
    const descontoTotal = value.replace(',', '.')

    if (isNaN(descontoTotal) || descontoTotal <= 0) {
      // Se o valor do desconto não é um número válido ou é menor ou igual a zero, não aplicamos desconto
      setDesconto(null) // Resetar o desconto para zero
      const updatedProdutos = produtos.map((produto) => ({
        ...produto,
        desconto: 0, // Define o desconto de cada produto como zero
        valor_total_item: produto?.quantidade * produto.valorunitario, // Atualiza o valor total do item sem desconto
      }))
      setProdutos(updatedProdutos) // Atualiza a lista de produtos
      return
    }

    // Calcula o valor total da compra
    const vl_total = produtos.reduce(
      (acc, produto) => acc + (produto.valor_total_item || 0),
      0,
    )

    // Calcula a proporção de desconto que cada item deve receber
    const proporcaoDesconto = descontoTotal / vl_total

    const updatedProdutos = produtos.map((produto) => {
      const quantidade = produto?.quantidade
      const valorUnitario = produto.valorunitario

      if (!isNaN(quantidade) && !isNaN(valorUnitario)) {
        // Calcula o valor total do item com desconto
        const valorTotalItemComDesconto =
          quantidade * valorUnitario -
          proporcaoDesconto * (produto.valor_total_item || 0)

        // Calcula o desconto proporcional para o item atual
        const valorDesconto =
          proporcaoDesconto * (produto.valor_total_item || 0)

        return {
          ...produto,
          desconto: valorDesconto.toFixed(2),
          valor_total_item: parseFloat(valorTotalItemComDesconto.toFixed(2)), // Atualiza o valor total do item com desconto
          valor_novo: quantidade * valorUnitario,
        }
      }

      return produto
    })

    setDesconto(descontoTotal)
    setProdutos(updatedProdutos)
  }

  const handleIdCliente = (id) => {
    setIdCliente(id)
  }

  const handleCpf = (cpf) => {
    setCpf(cpf)
  }

  const handleDescontoChange = (value, index) => {
    console.log(value)
    const updatedProdutos = [...produtos]
    const produto = updatedProdutos[index]

    const quantidade = produto?.quantidade
    const valorUnitario = produto.valorunitario
    const desconto = value

    if (!isNaN(quantidade) && !isNaN(valorUnitario) && !isNaN(desconto)) {
      const valorTotalItem = quantidade * valorUnitario - desconto
      produto.valor_total_item = valorTotalItem
      produto.desconto = value
    } else {
      produto.valor_total_item = 0
    }

    setProdutos(updatedProdutos)
  }

  // Função para formatar o número
  const formatarNumero = (numero) => {
    // Usar o toFixed(2) para limitar o número a duas casas decimais
    return numero.toFixed(2).replace('.', ',')
  }

  const parseDecimalValue = (value) => {
    const sanitizedValue = value.replace(',', '.')
    const parsedValue = parseFloat(sanitizedValue)
    return isNaN(parsedValue) ? '' : parsedValue.toFixed(2)
  }

  const alternarModoBusca = () => {
    setEstaBuscando((estadoAnterior) => !estadoAnterior)
  }

  const formatValue = (value) => {
    if (value == null) {
      return '' // Return an empty string or any default value for null or undefined values
    }
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }

  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    setDadosPedido((prevState) => ({
      ...prevState,
      cliente: nome,
    }))
  }

  const handleObsChange = (value, index) => {
    const updatedProdutos = [...produtos] // Create a copy of the produtos array
    updatedProdutos[index].obs = value // Update the obs value of the corresponding product
    setProdutos(updatedProdutos) // Update the state with the modified array
  }

  function handleProdutoIdChange(id, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].codigo = id
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChange(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    // updatedProdutos[index].codigo = '999999';
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChangeInput(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    updatedProdutos[index].codigo = '999999'
    setProdutos(updatedProdutos)
  }

  function handleProdutoInternoChange(prodInterno, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].id = prodInterno
    setProdutos(updatedProdutos)
  }

  function AdicionarProduto() {
    const prod = {
      id: uuidv4(),
      codigo: 0,
      descricao: '',
      quantidade_nova: 1,
      valorunitario: 0,
      valor_total_item: 0,
      desconto: 0,
    }

    setProdutos([...produtos, prod])
  }

  function ExcluirProduto(id_item) {
    const updatedProdutos = produtos.filter((prod) => prod.id !== id_item)
    setProdutos(updatedProdutos)
  }

  async function Estornar(sku, id_item, id_pedido) {
    console.log(statusPedido)
    if (statusPedido !== 'Atendido') {
      toast.warning(
        'O pedido não está no status "Atendido". Não é possível estornar.',
      )
      return
    }

    const confirmacao = window.confirm(
      'Tem certeza que deseja estornar este item?',
    )
    if (!confirmacao) {
      console.log('Estorno cancelado pelo usuário.')
      return
    }

    try {
      const response = await apinode.get(
        `/pedido/estorno/${id_item}/${sku}/${id_pedido}/${localStorage.idconta}`,
        {},
      )
      console.log(response.data)
      // Exibir mensagem de sucesso
      toast.success('Estorno realizado com sucesso!')
    } catch (error) {
      console.error('Erro ao estornar:', error)
      // Exibir mensagem de erro
      toast.error('Erro ao estornar o item: ' + error.message)
    }
  }

  function buscapedido(idpedido) {
    setLoadingTela(true)

    apinode
      .get(`/pedido/pedido-editar/${idpedido}/${localStorage.idconta}`, {})
      .then((response) => {
        console.log(response.data)

        // Extrai os dados do pedido
        const {
          datadespacho,
          cliente,
          cod_vendedor,
          id_parceiro,
          cpf,
          data,
          id_cliente,
          desconto,
          desconto_din,
          detalhes_pedido,
          id_loja,
          idpedidoloja,
          end_ent,
          valor_frete,
          cobra_frete,
          nfe_pedido,
          id_nfe,
          lanc_contas,
          status,
          tipo_pedido,
          comissao_vendedor,
        } = response.data.dadospedido

        // Configura os estados com os dados do pedido
        setProdutos(response.data.dadospedido.items)
        setDadosPedido(response.data.dadospedido)
        setNomeCliente(cliente)
        setVendedor(cod_vendedor)
        setIndicacaoVenda(id_parceiro)
        setIdCliente(id_cliente || null)
        setCpf(cpf)
        setDetalhesPedido(detalhes_pedido)
        setDesconto(parseFloat(desconto_din))
        setContaSelecionada(id_loja)
        setIdpedidoLoja(idpedidoloja)
        setEndEnt(end_ent)
        const enderecoAtualizado = response.data.dadospedido.dadosCliente[0]
        if (
          enderecoAtualizado.pes_tipo !== 'F' &&
          enderecoAtualizado.pes_tipo !== 'J'
        ) {
          enderecoAtualizado.pes_tipo = 'F' // Ou atribua o valor desejado
        }
        setEndereco(enderecoAtualizado)

        const dataFormatada = format(new Date(data), 'yyyy-MM-dd')
        setDtPedido(dataFormatada)
        const dataFormatadaEntrega = datadespacho
          ? format(new Date(datadespacho), 'yyyy-MM-dd')
          : null
        setDtEntrega(dataFormatadaEntrega)
        setFrete(valor_frete || 0)
        setCobraFrete(cobra_frete)
        setResultado(response.data.dadospedido.duplicatas)
        console.log(resultado)
        setNfepedido(nfe_pedido)
        setIdNfe(id_nfe)
        setLanContas(lanc_contas)
        setStatus(status)
        setTipoVenda(tipo_pedido)
        setComissao(comissao_vendedor || null)

        console.log(dataFormatada)
        setLoadingTela(false)
      })
      .catch((error) => {
        console.error(error)
        setLoadingTela(false)
      })
  }

  function formatDate(dateString) {
    if (!dateString) return '' // Handle empty or undefined dateString

    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function CarregarDadosPedido(id_ped) {
    if (id_ped > 0) {
      //setIdCliente(dadospedido?.id_cliente ?? 0);
      // setNomeCliente(dadospedido?.cliente);
      // setCpf(dadospedido?.cpf)

      const formattedDate = moment(dadospedido?.data).format('YYYY-MM-DD')
      setDtPedido(formattedDate)

      setVendedor(dadospedido?.cod_vendedor)
      setParceiro(dadospedido?.id_parceiro)

      setIdCondPagto(2)
      setDtEntrega('2023-10-30')
      // setObs("Teste");
      // setDesconto(dadospedido?.desconto_din);
      setDetalhesPedido(dadospedido?.detalhes_pedido)
    } else {
      setIdCliente(0)
      setDtPedido(moment().format('YYYY-MM-DD'))
      setIdCondPagto(0)
      setDtEntrega(moment().format('YYYY-MM-DD'))
      setObs('')
      setDesconto(0)
      setVendedor('')
      setIndicacaoVenda('')
      setProdutos([])
    }
  }

  function PesquisarClientes() {
    setListaClientes([])
  }

  function PesquisarProdutos() {
    setListaProdutos([
      { id_item: 1, id_produto: 1, descricao: 'MONITOR DELL' },
      { id_item: 2, id_produto: 2, descricao: 'HD SEAGATE 2TB' },
      { id_item: 3, id_produto: 3, descricao: 'MOUSE LOGITECH' },
    ])
  }

  function PesquisarCondPagtos() {
    setCondPagtos([
      { id_cond_pagto: 1, cond_pagto: '30 Dias' },
      { id_cond_pagto: 2, cond_pagto: '45 Dias' },
    ])
  }

  function handleDescricaoChange(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].descricao = value
      return newProdutos
    })
  }

  function handleQtdChange(qtd, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].quantidade = qtd
    updatedProdutos[index].valor_total_item =
      qtd * updatedProdutos[index].valorunitario
    updatedProdutos[index].valor_novo =
      qtd * updatedProdutos[index].valorunitario
    setProdutos(updatedProdutos)
  }

  function handleVlUnitChange(vl, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].valorunitario = vl
    updatedProdutos[index].valor_total_item =
      updatedProdutos[index].quantidade * vl
    updatedProdutos[index].valor_novo = updatedProdutos[index].quantidade * vl

    console.log('valor_total_item:', updatedProdutos[index].valor_total_item) // Linha de depuração

    handleDescontoChange(updatedProdutos[index].desconto, index) // Passa o valor do desconto atualizado

    if (
      typeof updatedProdutos[index].valor_total_item === 'number' &&
      !isNaN(updatedProdutos[index].valor_total_item)
    ) {
      updatedProdutos[index].valor_novo =
        updatedProdutos[index].valor_total_item
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      updatedProdutos[index].valor_novo =
        updatedProdutos[index].valor_total_item
      console.error('Erro: valor_total_item não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }

  function CalculaTotal() {
    let total = 0
    produtos.forEach((prod) => {
      total += prod.valor_total_item
    })
    setVlTotal(total)
  }

  function SalvarDados() {
    if (statusPedido === 'Atendido') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Status do pedido não permite alterações',
      })
      return
    } else if (statusPedido === 'Cancelado') {
      Swal.fire({
        icon: 'info',
        title: 'Pedido Cancelado',
        text: 'O pedido já foi cancelado e não pode ser alterado',
      })
      return
    }

    if (!contaSelecionada || contaSelecionada.trim() === 'all') {
      toast.warning('Erro, o campo conta é obrigatório.')
      setLoading(false)

      return
    }

    if (!tipoVenda || tipoVenda.trim() === 'all') {
      toast.warning('Selecione o tipo de pedido')
      setLoading(false)
      document.getElementById('tipovenda').focus() // Dar foco ao campo tipoVenda
      return
    }

    setLoading(true)

    if (!nomeCliente) {
      toast.warning('Erro, o campo cliente é obrigatório.')
      setLoading(false)
      return
    }

    if (
      produtos.length === 0 ||
      produtos.some((produto) => produto.descricao.trim() === '')
    ) {
      toast.warning(
        'Erro, é necessário adicionar pelo menos um produto com a descrição preenchida.',
      )
      setLoading(false)
      return
    }

    toast.info('Reservando estoque...')

    const dados_pedido = {
      valor_frete: frete,
      id_loja: contaSelecionada,
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: desconto || null,
      desconto_din: desconto || 0,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      detalhes_pedido: detalhesPedido || 'Não informado',
      end_ent: endEnt || null,
      itens: produtos,
      dadosDoCliente: endereco,
      cobra_frete: cobraFrete,
      duplicatas: resultado,
      user: localStorage.idusuario,
      tipo_pedido: tipoVenda || null,
      comissao: comissao || null,
    }

    toast.info('Parametrizando dados...')

    if (id_pedido === 'novo') {
      apinode
        .post(`/pedido/${localStorage.idconta}`, dados_pedido)
        .then((response) => {
          const novoPedidoId = response.data.idpedido
          toast.success('Pedido criado com sucesso!')
          setLoading(false)
          navigate(`/pedido/editar/${novoPedidoId}`)
        })
        .catch((error) => {
          console.error(error)
          toast.error('Erro ao criar o pedido: ' + error.message)
          setLoading(false)
        })
    } else {
      apinode
        .put(`pedido/${id_pedido}/${localStorage.idconta}`, dados_pedido)
        .then((response) => {
          toast.success('Alterações realizadas com sucesso!')
          setLoading(false)
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            Swal.fire({
              icon: 'error',
              title: 'Não é possível salvar o pedido',
              text: 'O processo de conferência já se iniciou. Estorne o pedido e faça as alterações necessárias.',
              footer: '<a href="#" id="link-why">Estornar itens</a>',
              didOpen: () => {
                document
                  .getElementById('link-why')
                  .addEventListener('click', () => {
                    handleEstorno(id_pedido) // Chame sua função aqui
                  })
              },
            })
          } else {
            console.error(error)
            toast.error('Erro ao atualizar o pedido: ' + error.message)
          }
          setLoading(false)
        })
    }
    toast.info('Gerando conferência de dados...')
  }

  const handleCheckboxChange = (event) => {
    // Use event.target.checked to check if the checkbox is checked
    // If checked, set 'S', otherwise set null
    const newValue = event.target.checked ? 'S' : null

    // Set the state using the newValue
    setCobraFrete(newValue)

    console.log('cobrafrete', newValue)
  }

  const handleTextoChange = (texto) => {
    setTextoDigitado('texto' + texto)
  }

  useEffect(() => {
    reqToken(localStorage.idconta)
    localStorage.setItem('id_conta', localStorage.idconta)
    PesquisarClientes()
    PesquisarProdutos()
    PesquisarCondPagtos()

    if (id_pedido > 0) {
      buscapedido(id_pedido)
    } else {
      const now = new Date() // Cria um objeto Date representando a data e hora atuais

      // Formata a data no formato "yyyy-MM-dd"
      const dataFormatada = now.toISOString().slice(0, 10)

      setDtPedido(dataFormatada)
    }

    if (desconto > 0) {
      handleDescontoTotal()
    }

    //  CarregarDadosPedido(id_pedido)
  }, [])

  useEffect(() => {
    const prepararParaImpressao = async () => {
      await CalculaTotal() // Aguarda a conclusão de CalculaTotal()

      if (print === 'print') {
        ImpPdf('Completo')
      }
    }

    prepararParaImpressao() // Chama a função assíncrona
  }, [produtos])

  useEffect(() => {
    fetchAccounts()

    // Fazer a requisição para obter os vendedores
    apinode
      .get(`vendedores/vendedor?conta=${localStorage.idconta}`)
      .then((response) => {
        setVendedores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    apinode
      .get(`vendedores/parceiros?conta=${localStorage.idconta}`)
      .then((response) => {
        setParceiros(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  if (parceiros.length > 0) {
    parceiros.sort((a, b) => {
      const nomeA = a.PES_RAZAO.toLowerCase()
      const nomeB = b.PES_RAZAO.toLowerCase()
      if (nomeA < nomeB) {
        return -1
      }
      if (nomeA > nomeB) {
        return 1
      }
      return 0
    })
  }

  return (
    <>
      <Navbar />

      {loadingTela ? (
        <div
          className={`container-fluid mt-page form-pedido-editar ${
            loadingTela ? 'loading' : ''
          }`}
        >
          <div className="text-center">
            <Spinner
              animation="border"
              role="status"
            >
              <span className="visually-hidden">Carregando...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div className="container-fluid mt-page form-pedido-editar">
          <div className="row col-lg-12 offset-lg-12">
            <div className="col-12 mb-4 mt-2">
              <h2
                className="d-inline"
                style={{ color: '#999999' }}
              >
                {id_pedido > 0
                  ? `Pedido de venda - ${id_pedido}`
                  : 'Novo pedido'}
              </h2>
            </div>
            <div className="col-md-6 mb-2">
              <label
                style={{ color: '#999999' }}
                htmlFor="InputNome"
                className="form-label"
              >
                Cliente
              </label>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <AutocompleteClienteNode
                  placeholder="Pesquisar cliente...."
                  onClickNome={handleNomeCliente}
                  onClickId={handleIdCliente}
                  onClickCpf={handleCpf}
                  value={nomeCliente}
                  className="form-control"
                />
                <button
                  type="button"
                  className="btn btn-outline-primary ms-2 d-flex align-items-center"
                  onClick={handleOpenAddressModal}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </div>
            </div>
            <div className="col-md-2 mb-2">
              <label
                style={{ color: '#999999' }}
                htmlFor="InputEmail"
                className="form-label"
              >
                Data do pedido
              </label>
              <input
                type="date"
                onChange={(e) => setDtPedido(e.target.value)}
                value={dt_pedido}
                className="form-control form-control-sm"
                id="InputEmail"
                aria-describedby="email"
              />
            </div>

            <div className="col-md-3 mb-2">
              <label
                style={{
                  marginBottom: '5px',
                  display: 'block',
                  color: '#999999',
                }}
              >
                Selecionar conta
              </label>
              <Form.Select
                id="storeDropdown"
                className="form-select search-input"
                value={contaSelecionada}
                onChange={handleContaChange}
                style={{
                  height: '38px',
                  width: '200px',
                  border: '1px solid #ced4da',
                  fontSize: '13px',
                }}
                size="sm"
              >
                <option value="all">Selecione uma Conta</option>
                {contas.map((option) => (
                  <option
                    key={option.ID_CONTA}
                    value={option.ID_CONTA}
                  >
                    {option.APELIDO}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/*   <div className="row"> */}
            <div className="col-md-2 mb-2">
              <label
                style={{
                  marginBottom: '4px',
                  display: 'block',
                  color: '#999999',
                }}
              >
                Tipo Pedido
              </label>

              <Form.Select
                id="tipovenda"
                className="form-select search-input"
                value={tipoVenda}
                onChange={handleTipoVenda}
                style={{
                  height: '38px',
                  width: '220px',
                  border: '1px solid #ced4da',
                  fontSize: '13px',
                }}
                size="sm"
              >
                <option value="all">Selecione o tipo do pedido</option>
                <option value="COMPRA">Compra</option>
              </Form.Select>
            </div>
            {/*    </div> */}

            <div className="container">
              <div className="d-flex align-items-center">
                <div
                  style={{ color: '#999999' }}
                  className="col-md-2 mb-2 mr-2"
                >
                  <label
                    htmlFor="InputEmail"
                    className="form-label"
                  >
                    Frete
                  </label>
                  <input
                    type="text"
                    onChange={(e) => setFrete(e.target.value)}
                    value={frete.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                    className="form-control form-control-sm"
                    id="InputEmail"
                    aria-describedby="email"
                  />
                </div>

                <div
                  style={{ color: '#999999' }}
                  className="col-md-2 mt-5 mb-3 ms-2"
                >
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="calcularFreteCheckbox"
                      checked={cobraFrete}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="calcularFreteCheckbox"
                    >
                      Calcular Frete
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div>
              {/* Adicione um botão ou chave de alternância para trocar entre o modo de busca e entrada manual */}
              <button
                type="button"
                onClick={alternarModoBusca}
                className="botao-estilizado mb-3"
              >
                {/* Adicione o ícone do Bootstrap ao botão com o texto */}
                {estaBuscando ? (
                  <>
                    <i className="bi bi-search"></i> Buscar
                  </>
                ) : (
                  <>
                    <i className="bi bi-pencil"></i> Inserção Manual
                  </>
                )}
              </button>

              <div className="table-responsive">
                <div className="col-12">
                  <Table
                    striped
                    hover
                    responsive
                  >
                    <thead>
                      <tr>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Sku
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Produto
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Qtd
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Valor Unit.
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Desconto
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Valor Total
                        </th>
                        <th
                          style={{ color: '#999999' }}
                          className="text-dark"
                        >
                          Obs
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {produtos.map((produto, index) => (
                        <tr key={produto.id}>
                          <td style={{ width: '100px' }}>
                            <Form.Control
                              type="text"
                              value={produto.codigo}
                              size="sm"
                            />
                          </td>
                          <td style={{ width: '650px' }}>
                            {estaBuscando ? (
                              <AutocompleteProdutoMatch
                                placeholder="Produto banco..."
                                onClickId={(id) =>
                                  handleProdutoIdChange(id, index)
                                }
                                onClickNome={(nome) =>
                                  handleProdutoNomeChange(nome, index)
                                }
                                onClickProdInterno={(prodInterno) =>
                                  handleProdutoInternoChange(prodInterno, index)
                                }
                                OnClickValor={(vlr) =>
                                  handleVlUnitChange(vlr, index)
                                }
                                OnClickCusto={(vlr) => handleCusto(vlr, index)}
                                ClickTexto={handleTextoChange}
                                value={produto.descricao}
                                className="form-control"
                                size="sm"
                              />
                            ) : (
                              <Form.Control
                                type="text"
                                placeholder="Inserir manualmente..."
                                value={produto.descricao}
                                onChange={(e) =>
                                  handleProdutoNomeChangeInput(
                                    e.target.value,
                                    index,
                                  )
                                }
                                size="sm"
                              />
                            )}
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              onChange={(e) =>
                                handleQtdChange(
                                  e.target.value.replace(',', '.'),
                                  index,
                                )
                              }
                              value={
                                produto.quantidade !== undefined &&
                                produto.quantidade !== null
                                  ? produto.quantidade
                                      .toString()
                                      .replace('.', '.')
                                  : ''
                              }
                              size="sm"
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              onChange={(e) =>
                                handleVlUnitChange(e.target.value, index)
                              }
                              value={
                                produto.valorunitario !== undefined &&
                                produto.valorunitario !== null
                                  ? produto.valorunitario
                                      .toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                      })
                                      .replace(',', '.') // Substitui vírgula por ponto
                                  : 0
                              }
                              size="sm"
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={
                                formatValue(produto.desconto).replace(
                                  ',',
                                  '.',
                                ) || 0
                              }
                              onChange={(e) =>
                                handleDescontoChange(
                                  e.target.value.replace(',', '.'), // Aqui também trocamos vírgulas por pontos
                                  index,
                                )
                              }
                              size="sm"
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              value={(produto.valor_total_item !== undefined &&
                              produto.valor_total_item !== null
                                ? produto.valor_total_item.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                    },
                                  )
                                : 0
                              ).replace(',', '.')}
                              disabled
                              size="sm"
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              value={produto.obs}
                              onChange={(e) =>
                                handleObsChange(e.target.value, index)
                              }
                              size="sm"
                            />
                          </td>
                          <td>
                            <div className="btn-group">
                              <Button
                                variant="danger"
                                onClick={(e) => {
                                  if (statusPedido !== 'Atendido') {
                                    ExcluirProduto(produto.id)
                                  }
                                }}
                                size="sm"
                                disabled={statusPedido === 'Atendido'}
                              >
                                <i className="bi bi-trash3-fill"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {produtos.length === 0 && (
                    <div className="no-item">Nenhum produto cadastrado</div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={AdicionarProduto}
              >
                Adicionar Produto
              </button>
            </div>

            <div className="col-md-6 text-end mb-5">
              <span className="me-4">Total Pedido:</span>
              <b>
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(vl_total)}
              </b>
            </div>

            <div className="col-12 mb-4">
              <label
                style={{ color: '#999999' }}
                htmlFor="InputNome"
                className="form-label"
              >
                Observações
              </label>
              <textarea
                type="text"
                onChange={(e) => setDetalhesPedido(e.target.value)}
                value={detalhesPedido}
                className="form-control"
              ></textarea>
            </div>

            <div className="col-12 mb-4">
              <label
                style={{ color: '#999999' }}
                htmlFor="InputNome"
                className="form-label"
              >
                Endereço de Entrega
              </label>
              <textarea
                type="text"
                onChange={(e) => setEndEnt(e.target.value)}
                value={endEnt}
                className="form-control"
              ></textarea>
            </div>

            {/*  tabela de parcelas */}

            <div>
              <div className="row mb-3">
                <div className="col-md-6">
                  <label
                    htmlFor="diasParcelas"
                    style={{ color: '#999999' }}
                    className="form-label"
                  >
                    Dias para as Parcelas (separados por vírgula):
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="diasParcelas"
                      value={diasParcelas}
                      onChange={(e) => setDiasParcelas(e.target.value)}
                      size={'sm'}
                    />
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={calcularParcelas}
                    >
                      Calcular Parcelas
                    </button>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <h5>Parcelas:</h5>
                <table
                  className="table table-sm"
                  style={{ fontSize: '12px' }}
                >
                  <thead>
                    <tr>
                      <th>Parcela</th>
                      <th>Vencimento</th>
                      <th>Valor</th>
                      <th>Anotações</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultado.map((parcela) => (
                      <tr key={parcela.codigo}>
                        <td>{parcela.numero}</td>
                        <td>
                          {parcela.datavencimento
                            ? format(
                                new Date(parcela.datavencimento),
                                'dd/MM/yyyy',
                              )
                            : ''}
                        </td>
                        <td>
                          {parcela.valor.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                        </td>
                        <td>
                          <input
                            type="text"
                            value={parcela.obs}
                            onChange={(e) =>
                              handleEditarObservacao(
                                parcela.numero,
                                e.target.value,
                              )
                            }
                            className="form-control"
                            style={{ fontSize: '12px' }}
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleExcluirParcela(parcela.codigo)}
                            style={{ fontSize: '12px' }}
                          >
                            Excluir
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => HandleLanc()}
                >
                  <i className="bi bi-file-earmark-check"></i> Lançar Contas
                </button>
              </div>

              <div className="mt-4">
                <p>
                  Total da Compra:{' '}
                  <b>
                    {new Intl.NumberFormat('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    }).format(vl_total)}
                  </b>
                </p>
              </div>
            </div>

            {/*    fim tabela */}

            <div className="col-12 mt-3">
              {msg.length > 0 && (
                <div className="alert alert-danger mt-4 text-center">{msg}</div>
              )}
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className={`btn btn-warning me-4 ${
                    isLoading ? 'disabled' : ''
                  }`}
                  onClick={isLoading ? null : HandleEstoque}
                  style={{ backgroundColor: '#ffd700', borderColor: '#ffd700' }}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        className="me-2"
                      />
                      Processando...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faCartArrowDown}
                        className="me-2"
                      />
                      Ajuste de estoque
                    </>
                  )}
                </button>

                <button
                  type="button"
                  className={`btn btn-warning me-4 ${
                    isLoading ? 'disabled' : ''
                  }`}
                  onClick={isLoading ? null : HandleCreateNFE}
                  style={{ backgroundColor: '#ffd700', borderColor: '#ffd700' }}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        className="me-2"
                      />
                      Processando...
                    </>
                  ) : (
                    'Criar NFE'
                  )}
                </button>

                <button
                  type="button"
                  className={`btn btn-success me-4 ${
                    isLoading ? 'disabled' : ''
                  }`}
                  onClick={isLoading ? null : SalvarDados}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        className="me-2"
                      />
                      Processando...
                    </>
                  ) : (
                    'Salvar Dados'
                  )}
                </button>

                <button
                  type="button"
                  className="btn btn-danger me-4"
                  onClick={() => ImpPdf('Completo')}
                >
                  <i className="bi bi-file-pdf"></i> Imprimir PDF
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => ImpPdf('Resumo')}
                >
                  <i className="bi bi-file-pdf"></i> Imp. espelho
                </button>
              </div>
            </div>
          </div>

          <Modal
            show={showAddressModal}
            onHide={handleCloseAddressModal}
            dialogClassName="custom-modalzpl"
          >
            <form onSubmit={HandleCadastrarCliente}>
              <Modal.Header closeButton>
                <Modal.Title>Dados do Cliente</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row g-3">
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="tipoCadastro"
                      className="form-label"
                    >
                      Tipo de Cadastro:
                    </label>
                    <select
                      className="form-select"
                      id="tipoCadastro"
                      value={endereco.pes_tipo || 'F'}
                      onChange={handleTipoCadastroChange}
                    >
                      <option value="F">Pessoa Física</option>
                      <option value="J">Pessoa Jurídica</option>
                    </select>
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="tipoCadastro"
                      className="form-label"
                    >
                      Contribuinte:
                    </label>
                    <select
                      className="form-control"
                      id="TipoContribuinte"
                      size="1"
                      value={endereco.cod_tipo_contribuinte}
                      onChange={handleTipoContribuinte}
                    >
                      <option value="1">CONTRIBUINTE ICMS</option>
                      <option value="2">CONTRIBUINTE ISENTO</option>
                      <option value="9">NAO CONTRIBUINTE</option>
                      <option value="99">NAO SELECIONADO</option>
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="nome"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'Nome' : 'Nome da Empresa'}:
                    </label>
                    <input
                      required="true"
                      type="text"
                      className="form-control"
                      id="nome"
                      value={endereco.pes_razao}
                      onChange={handleNomeChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="cpfCnpj"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'CPF' : 'CNPJ'}:
                    </label>
                    <ReactInputMask
                      mask={
                        endereco.pes_tipo === 'F'
                          ? '999.999.999-99'
                          : '99.999.999/9999-99'
                      }
                      maskChar={null} // Remove os caracteres de espaço reservado (_)
                      value={endereco.pes_cnpj_cpf}
                      onChange={handleCpfCnpjChange}
                      className="form-control"
                      id="cpfCnpj"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="rgie"
                      className="form-label"
                    >
                      {endereco.pes_tipo === 'F' ? 'RG' : 'Insc. Estadual'}:
                    </label>
                    <input
                      value={endereco.pes_insc_estadual}
                      onChange={handleRGIEChange}
                      className="form-control"
                      id="rgie"
                    />
                  </div>
                  <div className="col-md-3 mb-3">
                    <label
                      htmlFor="cep"
                      className="form-label"
                    >
                      CEP:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cep"
                      value={endereco.pes_cep}
                      onChange={handleCepChange}
                      onBlur={buscaCep}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="rua"
                      className="form-label"
                    >
                      Rua:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="rua"
                      value={endereco.pes_logradouro}
                      onChange={handleRuaChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="rua"
                      className="form-label"
                    >
                      Bairro:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bairro"
                      value={endereco.pes_bairro}
                      onChange={handleBairroChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="numero"
                      className="form-label"
                    >
                      Número:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="numero"
                      value={endereco.pes_numero}
                      onChange={handleNumeroChange}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label
                      htmlFor="cidade"
                      className="form-label"
                    >
                      Cidade:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cidade"
                      value={endereco.pes_cidade}
                      onChange={handleCidadeChange}
                    />
                  </div>
                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="estado"
                      className="form-label"
                    >
                      Estado:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="estado"
                      value={endereco.pes_uf}
                      onChange={handleEstadoChange}
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="estado"
                      className="form-label"
                    >
                      Ibge:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="ibge"
                      value={endereco.pes_ibge}
                      onChange={handlePesIbge}
                    />
                  </div>

                  <div className="col-md-2 mb-3">
                    <label
                      htmlFor="telefone"
                      className="form-label"
                    >
                      Telefone:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="telefone"
                      value={endereco.pes_telefone}
                      onChange={handleTelefoneChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label
                      htmlFor="celular"
                      className="form-label"
                    >
                      Celular:
                    </label>
                    <InputMask
                      mask="(99) 99999-9999"
                      maskChar="_"
                      className="form-control"
                      id="celular"
                      value={endereco.pes_celular}
                      onChange={handleCelularChange}
                    />
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                {id_pedido === 'novo' && (
                  <Button
                    variant="success"
                    type="submit"
                  >
                    Cadastrar Cliente
                  </Button>
                )}

                <Button
                  variant="secondary"
                  onClick={handleCloseAddressModal}
                >
                  Fechar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>

          <Modal
            show={showModal}
            onHide={handleCloseModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>NFE Criada com Sucesso!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                A NFE foi criada com sucesso. Clique no link abaixo para
                visualizá-la:
              </p>
              <a
                href={`/nfe/editar/${idNFe}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar NFE
              </a>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseModal}
              >
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showModalEst}
            onHide={handleCloseModalEst}
            dialogClassName="custom-modalzpl"
          >
            <Modal.Header closeButton>
              <Modal.Title>Realizar baixa de estoque</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p style={{ color: '#c0c0c0', fontSize: '12px' }}>
                Selecione os itens para baixa.
              </p>
              <Table
                striped
                bordered
                hover
                style={{ fontSize: '12px' }}
              >
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Descrição</th>
                    <th>Quantidade</th>
                    <th>Selecionar</th>
                  </tr>
                </thead>
                <tbody>
                  {produtosEstoque.map((produto) => (
                    <tr key={produto.sku}>
                      <td>{produto.sku}</td>
                      <td>{produto.descricao}</td>
                      <td>{produto?.quantidade}</td>
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={
                            quantidadesSelecionadas[produto.sku]?.selected ||
                            false
                          }
                          onChange={() =>
                            handleCheckboxChangeEst([
                              produto.sku,
                              produto?.quantidade,
                            ])
                          }
                          disabled={produto.lancado === '0S'}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseModalEst}
              >
                Fechar
              </Button>
              <Button
                variant="primary"
                onClick={HandleBaixarEstoque}
              >
                {isLoading ? (
                  <>
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      className="me-2"
                    />
                    Processando...
                  </>
                ) : (
                  'Realizar Baixa de Estoque'
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  )
}

export default PedidoCompra
